import { Box, Typography } from "@mui/material";
import './pageHeader.css';

export function PageHeader() {
    return (
        <Box className="page-header">
            <Box className="header-content">
                <img src={process.env.PUBLIC_URL + '/afya-logo.svg'} alt="Afya Logo" className="afya-logo" />
                
                <Typography variant="h1" component="h1" className="header-title">
                    Formulário clínico de rastreio simplificado baseado em mFARS
                </Typography>
            </Box>
            <Box className="sponsored-section">
            </Box>
        </Box>
    );
}